import throttle from 'lodash.throttle';
import { ApiNotificationType } from '@izimi/api';
import { notificationItems } from '../../notifications/notificationItems';
export const RealtimeDatabaseEventKeys = {
    BOX_DOCUMENT_COPIED_TO_VAULT: 'BOX_DOCUMENT_COPIED_TO_VAULT',
};
let cachedFields;
const throttledCacheInvalidationsCallbacks = {};
export const snapshotHandler = ({ data, cacheInvalidationFns, onEvent }) => {
    const fields = data.data();
    let invalidateNotificationCache = false;
    if (!fields || cachedFields == null) {
        cachedFields = fields;
        return;
    }
    // We have to throttle this callback because the user can copy many files at once, triggering a lot of nearly simultaneous events.
    if (throttledCacheInvalidationsCallbacks.BOX_COPIED_TO_VAULT == null) {
        throttledCacheInvalidationsCallbacks.BOX_COPIED_TO_VAULT = throttle(() => {
            cacheInvalidationFns.invalidateCommunicationsCache();
            cacheInvalidationFns.invalidateSharedItemsCache();
            cacheInvalidationFns.invalidateDocumentsSharedToYouListCache();
            cacheInvalidationFns.invalidateDocumentsVaultListCache();
            cacheInvalidationFns.invalidateVaultInfoCache();
        }, 1000, { trailing: true });
    }
    Object.entries(fields).forEach(([key, value]) => {
        if (cachedFields?.[key]?.toString() === value.toString()) {
            return null;
        }
        if (notificationItems[key] != null) {
            invalidateNotificationCache = true;
        }
        if (onEvent) {
            onEvent({ [key]: value });
        }
        switch (key) {
            case RealtimeDatabaseEventKeys.BOX_DOCUMENT_COPIED_TO_VAULT:
                return throttledCacheInvalidationsCallbacks.BOX_COPIED_TO_VAULT?.();
            case ApiNotificationType.ContactRequestAccepted:
            case ApiNotificationType.ContactRequestReceived:
            case ApiNotificationType.ContactRemoveReceived:
                cacheInvalidationFns.invalidateContactsCache();
                return cacheInvalidationFns.invalidateContactRequestsCache();
            case ApiNotificationType.VaultTransferReceived:
                return cacheInvalidationFns.invalidateVaultInfoCache();
            case ApiNotificationType.PushedDocumentsReceived:
                cacheInvalidationFns.invalidateSharedItemsCache();
                return cacheInvalidationFns.invalidateDocumentsSharedFromNotaryListCache();
            case ApiNotificationType.CommunicationReceived:
                cacheInvalidationFns.invalidateSharedItemsCache();
                return cacheInvalidationFns.invalidateCommunicationsCache();
            case ApiNotificationType.SharedDocumentsReceived:
            case ApiNotificationType.SharedDocumentUnshared:
            case ApiNotificationType.SharedDocumentUnsharedByRecipient:
            case ApiNotificationType.SharedDocumentsAccepted:
            case ApiNotificationType.DocumentUploadedByThirdParty:
            case ApiNotificationType.NotaryDocumentUnshared:
                cacheInvalidationFns.invalidateSharedItemsCache();
                cacheInvalidationFns.invalidateDocumentsVaultListCache();
                return cacheInvalidationFns.invalidateDocumentsSharedToYouListCache();
            default:
                return null;
        }
    });
    if (invalidateNotificationCache) {
        cacheInvalidationFns.invalidateLastNotificationsCache();
        cacheInvalidationFns.invalidateNotificationsCache();
    }
    cachedFields = fields;
};
